var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disclamer",class:_vm.disclamerCssClasses},[_c('h1',[_vm._v("ATTENTION VERSION BETA!!!")]),_c('p',[_vm._v(" Please utiliser avec prudence 😬")])])
}
var staticRenderFns = []

export { render, staticRenderFns }